import { Input, InputProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type Props<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const VersionInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: Props<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 50,
        message: 'バージョンは50文字以内にする必要があります。',
      },
    })}
    {...inputProps}
  />
);
